import { useSelector } from 'react-redux';
import { createAction, createReducer } from 'redux-act';

import { IGlobalState } from './index';

export type IState = {
  isWhitelabel: boolean;
};

export const setWhitelabel = createAction<boolean>('whitelabel/data/set');

export const getWhitelabel = (state: IGlobalState) => state.whitelabel.isWhitelabel;

export const useWhitelabel = (): boolean => {
  return useSelector(getWhitelabel);
};

export default createReducer<IState>({}, { isWhitelabel: false }).on(setWhitelabel, (_, isWhitelabel) => {
  return {
    isWhitelabel,
  };
});
